export const INIT_SOLID_PAYMENT = 'PAYMENT/INIT_SOLID_PAYMENT';
export const SET_SOLID_MERCHANT_DATA = 'PAYMENT/SET_SOLID_MERCHANT_DATA';
export const SET_MERCHANT_LOADING = 'PAYMENT/SET_MERCHANT_LOADING';
export const SOLID_POST_INIT = 'PAYMENT/SOLID_POST_INIT';
